import { CONTROL_FOCUS_CLASS } from "../lib/controlStyles";
import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";

import { cn } from "../lib/cn";

const controlClassName = [
  "w-full rounded-control border border-control-border bg-surface px-3 text-primary transition-colors",
  "placeholder:text-muted",
  "hover:border-control-border-hover",
  CONTROL_FOCUS_CLASS,
  "disabled:cursor-not-allowed disabled:bg-surface-elevated disabled:text-muted disabled:opacity-70",
  "read-only:cursor-default read-only:bg-surface-elevated read-only:text-muted",
  "aria-invalid:border-status-error aria-invalid:ring-2 aria-invalid:ring-status-error/20",
].join(" ");

export type ControlSize = "sm" | "md";

const controlSizeClasses: Record<ControlSize, string> = {
  sm: "density-control-sm text-xs",
  md: "density-control-md text-sm",
};

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  controlSize?: ControlSize;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, controlSize = "md", ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(controlClassName, controlSizeClasses[controlSize], className)}
      {...props}
    />
  );
});

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(controlClassName, "resize-y py-2 text-sm", className)}
      {...props}
    />
  );
});
